import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../pages/dashboard/dashboard.scss';
import { Box, MenuItem, Typography } from '@mui/material';
import { TextField } from '@efexteam/components';
import { englishMonths, spanishMonths } from './constants';

interface FirstStepAccountStatusProps {
  setValueDateIssue: (value: string) => void;
  setKeyDateIssue: (value: string) => void;
}

const FirstStepAccountStatus = ({
  setValueDateIssue,
  setKeyDateIssue,
}: FirstStepAccountStatusProps) => {
  const { t, i18n } = useTranslation();
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const monthNames = i18n.language === 'en' ? englishMonths : spanishMonths;

  const selectDateOfIssue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (!value) return;

    const [textMonth, year] = value.split(' ');
    const monthIndex = monthNames.indexOf(textMonth) + 1;

    setSelectedMonth(value);
    setValueDateIssue(`${monthIndex}-${year}`);
    setKeyDateIssue(value);
  };

  const controlDate = new Date();
  controlDate.setDate(1);
  const fullDateArray: string[] = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i <= 11; i++) {
    fullDateArray.push(
      `${monthNames[controlDate.getMonth()]} ${controlDate.getFullYear()}`
    );
    controlDate.setMonth(controlDate.getMonth() - 1);
  }

  return (
    <>
      <Box className="modal-header flex flex-shrink-0 items-center justify-between border-b border-gray-200 rounded-t-md">
        <Typography variant="h5">{t('cashStatement')}</Typography>
      </Box>
      <Box className="md:w-7/12 w-full mx-auto">
        <Box className="sheet">
          <Box className="sheet-items">
            <Typography variant="body1">{t('selectTheAirDate')}</Typography>
          </Box>
        </Box>
        <TextField
          select
          fullWidth
          className="!mt-0 !w-full capitalize"
          name="client"
          value={selectedMonth}
          onChange={selectDateOfIssue}
        >
          <MenuItem value="" disabled>
            {t('choose')}
          </MenuItem>
          {fullDateArray.map((month) => (
            <MenuItem key={month} value={month}>
              {month}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </>
  );
};

export default FirstStepAccountStatus;
